import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { clearAccessToken, getAccessToken, setAccessToken } from '@src/utils/token-store';

import { signedIn, signedOut } from './slices/auth';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  credentials: 'include',
  prepareHeaders: (headers) => {
    const token = getAccessToken();

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

let refreshPromise = null;

export const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (result?.error?.status === 403 && result?.error?.data?.error === 'SubscriptionRequired') {
    return result;
  }

  if (result?.error?.status !== 401) {
    return result;
  }

  if (!refreshPromise) {
    refreshPromise = attemptTokenRefresh(api, extraOptions).finally(() => {
      refreshPromise = null;
    });
  }

  const refreshSucceeded = await refreshPromise;

  if (!refreshSucceeded) {
    forceSignOut(api);

    return result;
  }

  return await rawBaseQuery(args, api, extraOptions);
};

async function attemptTokenRefresh(api, extraOptions) {
  const refreshResult = await rawBaseQuery(
    {
      url: '/auth/refresh-token',
      method: 'POST',
      body: {},
    },
    api,
    extraOptions,
  );

  if (refreshResult?.data) {
    setAccessToken(refreshResult.data.access_token);
    api.dispatch(signedIn());

    return true;
  }

  return false;
}

function forceSignOut(api) {
  clearAccessToken();
  api.dispatch(signedOut());
}
